import { Theme } from '@mui/material'
import { TFunction } from 'i18next'
import { CSSProperties } from 'react'
import TableHeaders from '../../../../Interfaces/TableHeaders'

export const getLCDLicensingBreakdownDetailsHeader = (
  theme: Theme,
  t: TFunction
): TableHeaders[] => {
  const licensingDueBreakDownCSSProps: CSSProperties = {
    color: theme.palette.primary.main,
    padding: theme.spacing(2, 0),
    minWidth: '88px',
    maxHeight: '30px',
    borderBottom: 1,
    borderColor: theme.palette.customBackground.divider,
    backgroundColor: 'transparent',
    paddingLeft: 0,
  }

  const breakdownHeaders: TableHeaders[] = [
    {
      label: t(
        'LCDLicensingBreakdownDetails.Breakdown.Header.FeeName',
        'Fee Name'
      ),
      align: 'left',
      cssProps: {
        ...licensingDueBreakDownCSSProps,
      },
    },
    {
      label: t(
        'LCDLicensingBreakdownDetails.Breakdown.Header.FeeAmount',
        'Fee Amount'
      ),
      align: 'right',
      cssProps: {
        ...licensingDueBreakDownCSSProps,
      },
    },
    {
      label: t(
        'LCDLicensingBreakdownDetails.Breakdown.Header.NumberOfStudents',
        '# Of Students'
      ),
      align: 'right',
      cssProps: {
        ...licensingDueBreakDownCSSProps,
      },
    },
    {
      label: t(
        'LCDLicensingBreakdownDetails.Breakdown.Header.DirectorOwesCC',
        'Director Owes CC'
      ),
      align: 'right',
      cssProps: {
        ...licensingDueBreakDownCSSProps,
      },
    },
  ]

  return breakdownHeaders
}
